<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" :showBackButton="false" />
      </b-col>
    </b-row>

    <b-row>
      <b-col md="2" lg="2">
        <h2 class="purple bold title">Aluno</h2>
      </b-col>

      <b-col class="text-right" md="10" lg="10">
        <b-col class="text-right" md="2" lg="2" style="justify-items: end">
          <b-button class="btn large blue" @click="() => $router.go(-1)">Voltar</b-button>
        </b-col>
        <template v-if="showButtons">
          <b-col md="3" lg="3">
            <b-button class="btn large blue" :disabled="isTeacherButtonDisabled" style="line-height: 20px"
              @click="() => aprovePeriodReportStatus('pending')">
              Liberar para os professores
            </b-button>
          </b-col>

          <b-col md="3" lg="3">
            <b-button class="btn large blue" :disabled="isParentButtonDisabled" style="line-height: 20px"
              @click="() => aprovePeriodReportStatus('approved')">
              Liberar para os responsáveis
            </b-button>
          </b-col>

          <b-col class="text-right" md="2" lg="2">
            <b-button class="btn large blue" @click="downloadStudentReport"
              :disabled="downloadLoading || !periodReport">
              {{ downloadLoading ? "Aguarde..." : "Exportar" }}
            </b-button>
          </b-col>
        </template>
      </b-col>
    </b-row>

    <div>
      <b-row>
        <b-col>
          <b-row class="profile-row">
            <b-col>
              <img v-if="photo == null || ''" src="@/assets/images/default-photo.png" height="64" width="64" alt />
              <img v-else width="64" height="64" :src="`${photo}`" alt />
              <div class="content-meeting">
                <div class="student-detail">
                  <h5>{{ user && user.name }}</h5>
                  <p v-if="cycle && cycle.designation">
                    {{ cycle.designation }}
                    <template v-if="1 === 2">
                      ({{ student.virtualYear }} º ano no
                      ciclo)
                    </template>
                    <br />
                    <template v-if="formatedCycleDuration && !isParentOrStudent">
                      <strong>Tempo no ciclo:</strong>
                      {{ formatedCycleDuration }}
                      <br />
                    </template>
                    <strong>Frequência total do ano:</strong>
                    {{ attendances.frequency }}%<br />
                    <template v-if="
                      activePeriod &&
                      activePeriod.from_date &&
                      activePeriod.to_date
                    ">
                      <strong>Período de referência do Informe:</strong>
                      {{ activePeriod.from_date }} a {{ activePeriod.to_date }}
                    </template>
                  </p>
                </div>
              </div>
            </b-col>
            <b-col>
              <div class="content-meeting">
                <div class="column">
                  <p>
                    <b>Carga horária anual</b>
                  </p>
                  <p v-if="cycle && cycle.workload">{{ cycle.workload }}h</p>
                </div>
                <div class="column">
                  <p>
                    <b>Limite permitido de faltas</b>
                  </p>
                  <p v-if="cycle && cycle.absence_limit_hours">
                    {{ cycle.absence_limit_hours }}h
                  </p>
                </div>
                <div class="column">
                  <p>
                    <b>Total de faltas/atrasos do aluno</b>
                  </p>
                  <p>
                    {{
                      attendances.time_absences
                        ? attendances.time_absences
                        : "0h"
                    }}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <div class="attendance-advice">
        <p v-if="cycle && cycle.absence_limit_perc_responsible">
          Ao atingir 30% do limite permitido de faltas ({{
            cycle.absence_limit_perc_responsible
          }}
          horas), a Escola tem obrigação legal de comunicar ao Conselho Tutelar
        </p>
      </div>
    </div>

    <b-row style="padding-top: 36px" v-if="periodReport && periodReport.description">
      <b-col>
        <h3>Tutoria</h3>
      </b-col>

      <b-col v-if="showButtons && (!periodReport || !periodReport.description)" class="text-right">
        <button class="notify-button" @click="() => notifyTutor()" :disabled="periodReport && periodReport.description">
          Notificar pendência
        </button>
      </b-col>
    </b-row>

    <b-row style="padding-top: 15px" v-if="loadedTutoring && periodReport && periodReport.description">
      <b-col class="col-observacoes">
        <div class="content-meeting">
          <div class="observacao-column" v-if="periodReport && periodReport.description">
            <span style="font-size: 16px; color: #666666">Observação referente à(ao) {{ periodReport.Period.name
            }}</span>
            <p style="
                white-space: pre-line;
                font-size: 18px;
                word-break: keep-all;
                overflow-wrap: break-word;
              ">
              {{ periodReport.description }}
            </p>
          </div>

          <div class="observacao-column" v-else>
            <p style="font-size: 18px; color: #b23066; font-weight: bold">
              Nenhuma observação registrada.
            </p>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row style="padding-top: 36px">
      <b-col>
        <h3>Evolução por Área do Conhecimento</h3>
      </b-col>

      <b-col v-if="showButtons" class="text-right">
        <button class="notify-button" @click="() => notifyTeacher()">
          Notificar pendência
        </button>
      </b-col>
    </b-row>

    <b-row style="padding-top: 20px">
      <b-col md="4" lg="4" class="menu-sidebar knowledge-menu" style="background-color: #f9f9f9">
        <div class="menu">
          <span v-if="subjectPendencyList.length > 0" class="menu-sidebar-title">Regulares - do {{ cycle.name }}</span>
          <ul style="padding-left: 0">
            <li class="side-item" v-for="subject in subjectList" :key="subject.id"
              :class="{ active: subject_id === subject.id }" @click="() => selectSubject(subject.id)">
              <span style="white-space: normal; word-break: break-word">
                {{ subject.designation }}
              </span>
            </li>
          </ul>

          <span v-if="subjectPendencyList.length > 0" class="menu-sidebar-title" style="
              margin-top: 20px;
              padding-top: 20px;
              border-top: 1px solid #e0e0e0;
            ">Pendentes - do {{ subjectPendencyList[0].cycle_name }}</span>
          <ul v-if="subjectPendencyList.length > 0" style="padding-left: 0">
            <li class="side-item" v-for="subject in subjectPendencyList" :key="subject.id"
              :class="{ active: subject_id === subject.id }" @click="() => selectSubject(subject.id)">
              <span style="white-space: normal; word-break: break-word">
                {{ subject.designation }}
              </span>
            </li>
          </ul>
        </div>
      </b-col>
      <b-col lg="9">
        <div v-if="!loadingChart">
          <div class="chart-container">
            <h3>Percentual de evolução do aluno</h3>
            <div class="flag-wrapper">
              <b-col class="subtitle-container">
                <span><b>Legenda:</b></span>
                <div class="flag-container">
                  <div class="subtitle">
                    <div class="flag-box">
                      <Flag />
                    </div>
                    <span> Evolução anual </span>
                  </div>

                  <div class="subtitle">
                    <ChartStar v-if="faixasCount === 1" />
                    <ChartHashure v-else />
                    <span>
                      Estimativa para conclusão do ciclo em
                      {{
                        faixasCount > 0
                          ? faixasCount === 1
                            ? "1 ano"
                            : faixasCount + " anos"
                          : "3 anos"
                      }}
                    </span>
                  </div>

                  <div class="subtitle">
                    <Exclamation />
                    <span>Retenção no ciclo</span>
                  </div>
                </div>
              </b-col>
            </div>
            <ui-line-chart id="myLineChart" :data="chartData" :current-year="year && year.id ? year.id : null"
              :percentages="cyclePercentages" class="box-chart"></ui-line-chart>
            <span v-b-tooltip.hover title="Progresso esperado" />
          </div>

          <div class="register-container">
            <div class="register-period">
              <div class="title-format">
                <div>
                  <span>REGISTROS DE APRENDIZAGEM
                    <span style="color: #b23066">DO PERÍODO</span>
                  </span>
                </div>
              </div>

              <b-row v-if="subjectTopics.length > 0">
                <b-col class="col-status" v-for="topic in subjectTopics" :key="topic.id">
                  <div class="title-status-content">
                    <div style="display: flex; gap: 10px">
                      <div class="status-content font-bold" :style="topic.status === 'EE'
                        ? 'background-color: #b23066;'
                        : topic.status === 'AN'
                          ? 'background-color: #ffbb00;'
                          : ''
                        ">
                        <span style="margin: 4px 18.5px; color: #fff">{{
                          topic.status
                        }}</span>
                      </div>
                      <div>
                        <span>
                          {{ topic.topics.length + "/" + topic.totalValid }}
                        </span>
                      </div>
                    </div>
                    <h5 style="font-size: 17px">{{ topic.title }}</h5>
                  </div>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="col-status" style="border: none" v-for="topic in subjectTopics" :key="topic.id">
                  <div class="register-item">
                    <ul v-if="topic.topics.length">
                      <span v-for="item in topic.topics" :key="item.id">
                        {{ item.competence_sort_order }}.{{
                          item.topic_sort_order
                        }}
                        {{ item.description }}
                      </span>
                    </ul>

                    <ul v-else>
                      <span>Nenhum conteúdo encontrado</span>
                    </ul>
                  </div>
                </b-col>
              </b-row>
            </div>

            <div class="register-cycle">
              <div class="title-format">
                <div>
                  <span>REGISTROS DE APRENDIZAGEM
                    <span style="color: #b23066">DO CICLO</span></span>
                </div>
              </div>

              <b-row v-if="subjectWithStatus.length > 0">
                <b-col class="col-status" v-for="topic in subjectWithStatus" :key="topic.id">
                  <div class="register-cycle-item">
                    <div class="status-content font-bold" :style="topic.status === 'EE'
                      ? 'background-color: #b23066;'
                      : topic.status === 'AN'
                        ? 'background-color: #ffbb00;'
                        : ''
                      ">
                      <span style="margin: 4px 18.5px; color: #fff">{{
                        topic.status
                      }}</span>
                    </div>
                    <span>
                      {{ topic.totalWithStatus }}/{{ topic.totalValid }}
                      {{
                        topic.status != "*"
                          ? "Conteúdos Aprendidos"
                          : "Conteúdos supostamente aprendidos em outra instituição de ensino"
                      }}
                    </span>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <div class="loading-spinner" v-if="loadingChart && !notActivePeriod">
          <span class="spinner-border spinner-border lg"></span>
        </div>
        <div v-if="notActivePeriod">
          <b-alert variant="danger" show>
            <h4 class="alert-heading">Período ativo não encontrado</h4>
            <p>Não foi possível encontrar o período ativo para o aluno.</p>
          </b-alert>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import UiLineChart from "@/components/chart/Linechart.vue";
import Flag from "@/components/svg/Flag.vue";
import Exclamation from "@/components/svg/Exclamation.vue";
import moment from "moment-timezone";
import { mapGetters } from "vuex";
import ChartHashure from "../../../components/svg/ChartHashure.vue";
import ChartStar from "../../../components/svg/ChartStart.vue";
import httpRda from "../../../http-rda";
import formatCycleDuration from "../../../utils/formatCycleDuration";
export default {
  name: "informe-periodico-detalhes",
  components: {
    UiLineChart,
    Flag,
    Exclamation,
    ChartHashure,
    ChartStar,
  },

  data() {
    return {
      breadcrumb: [
        {
          text: "Comunidade",
          href: "/comunidade",
        },
        {
          text: "Informe Periódico",
          href: "/comunidade/informe-periodico",
        },
        {
          text: "Aluno",
          href: "/informe-periodico-detalhes",
          active: true,
        },
      ],
      formatedCycleDuration: null,
      downloadLoading: false,
      loadingChart: true,
      notActivePeriod: false,
      subjectList: [],
      subjectPendencyList: [],
      subject_id: null,
      subjectTopics: [],
      subjectWithStatus: [],
      student: null,
      user: null,
      photo: null,
      cycle: null,
      cyclePercentages: null,
      year: null,
      attendances: 0,
      periodReport: null,
      activePeriod: null,
      bimontlyReportData: [],
      loadedTutoring: false,
      chartData: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: "transparent",
            borderColor: "#B23066",
            fill: false,
          },
        ],
      },
      chartOptions: {
        responsive: true,
      },
    };
  },

  computed: {
    ...mapGetters({
      loggedUser: "auth/getAuthData",
    }),

    faixasCount() {
      if (!this.cyclePercentages) return 0;
      return [
        this.cyclePercentages.faixa1,
        this.cyclePercentages.faixa2,
        this.cyclePercentages.faixa3,
      ].filter(Boolean).length;
    },

    studentId: {
      get() {
        return this.$route.params.id;
      },
    },

    showButtons() {
      return (
        !this.loggedUser.role.includes("parent") &&
        !this.loggedUser.role.includes("teacher") &&
        !this.loggedUser.role.includes("student")
      );
    },

    isTeacherButtonDisabled() {
      return this.periodReport && this.periodReport.status === "pending";
    },
    isParentButtonDisabled() {
      return this.periodReport && this.periodReport.status === "approved";
    },

    isParent() {
      return (
        this.loggedUser.role.length === 1 &&
        this.loggedUser.role.includes("parent")
      );
    },
    isStudent() {
      return (
        this.loggedUser.role.length === 1 &&
        this.loggedUser.role.includes("student")
      );
    },

    isParentOrStudent() {
      return this.isParent || this.isStudent;
    },
  },

  methods: {
    async downloadStudentReport() {
      if (!this.periodReport) {
        this.$swal.fire({
          icon: "error",
          title: "Erro!",
          text: "Relatório não encontrado.",
        });
        return;
      }

      try {
        this.downloadLoading = true;
        const response = await httpRda.get(
          `/bimontly-report/${this.studentId}/report`,
          {
            responseType: "blob",
          }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        link.href = url;

        const fileName = `relatorio-${this.user.name.replace(
          /\s+/g,
          ""
        )}-${this.cycle.designation.replace(/\s+/g, "")}-${moment().format(
          "DD-MM-YYYY"
        )}.pdf`;

        link.setAttribute("download", fileName);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);

        this.downloadLoading = false;
        this.$swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: "Relatório baixado com sucesso.",
        });
      } catch (error) {
        this.downloadLoading = false;
        this.$swal.fire({
          icon: "error",
          title: "Erro!",
          text: error.response?.data?.error || "Erro ao baixar relatório",
        });
        return error;
      }
    },

    async aprovePeriodReportStatus(status = "approved") {
      if (!this.activePeriod) {
        this.$swal.fire({
          icon: "error",
          title: "Erro!",
          text: "Período não encontrado.",
        });
        return;
      }

      this.$swal
        .fire({
          title: "Notificação",
          text: `Deseja liberar o relatório ${status === "approved"
            ? "para os responsáveis"
            : "apenas para os professores"
            } ? `,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Liberar",
          cancelButtonText: "Voltar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              const hasReport = !!this.periodReport;

              if (!hasReport) {
                await httpRda
                  .post("/period_reports", {
                    period_type: this.activePeriod.periodType,
                    period_id: this.activePeriod.id,
                    student_id: this.studentId,
                    description: "",
                    teacher_id: null,
                    status: status,
                  })
                  .then(async () => {
                    await this.getAllData();
                    this.$swal.fire({
                      icon: "success",
                      title: "Sucesso!",
                      text: "",
                    });
                  });
              } else {
                await httpRda
                  .patch(
                    `/bimontly-report/${this.studentId}/report/${this.periodReport.id}/change-period-report-status`,
                    {
                      status: status,
                    }
                  )
                  .then(async () => {
                    await this.getAllData();
                    this.$swal.fire({
                      icon: "success",
                      title: "Sucesso!",
                      text: "",
                    });
                  });
              }
            } catch (error) {
              this.$swal.fire({
                icon: "error",
                title: "Erro!",
                text: error.response.data.error,
              });

              return error;
            }
          }

          await this.getAllData();
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel concluir a ação!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error;
        });
    },

    async getStudent() {
      try {
        this.loadedTutoring = false;
        const response = await httpRda.get(`/students/${this.studentId}`);
        const currentUserIsResponsible =
          Array.isArray(response.data.student.Responsibles) &&
          response.data.student.Responsibles.some(
            (responsible) => responsible?.User?.id === this.loggedUser?.id
          );

        if (this.isParent && !currentUserIsResponsible) {
          this.$router.go(-1);
          return;
        }

        this.loadedTutoring = true;
        this.student = response?.data?.student || null;
        const timeInCycle = this.student?.timeInCycle;
        this.formatedCycleDuration = formatCycleDuration(timeInCycle?.years, timeInCycle?.months);

        if (this.student && this.student.User) {
          this.user = this.student?.User;
          this.photo = this.student?.User?.photo || "";
          this.cycle = this.student?.Cycle || null;
          const percentages =
            this.cycle &&
              this.cycle.CyclePercentages &&
              this.cycle.CyclePercentages.length
              ? this.cycle.CyclePercentages[0]?.percentages
              : null;

          this.cyclePercentages = JSON.parse(percentages || "{}");
          this.year = this.student.Year || null;
        }
      } catch (error) {
        return false
      }
    },

    async getYearAttendance() {
      const response = await httpRda.get(
        `/students/${this.studentId}/attendances`
      );

      this.attendances = response.data;
    },

    getPeriodReport() {
      httpRda
        .get(`/period_reports/${this.studentId}`)
        .then((response) => {
          this.periodReport = response.data.result.periodReport;
          this.activePeriod = response.data.result.activePeriod;
          if (
            !this.periodReport &&
            !this.showButtons &&
            (this.isParent || this.isStudent)
          ) {
            this.$router.go(-1);
          }

          this.notActivePeriod = false;

          if (this.activePeriod) {
            this.activePeriod.from_date = moment(
              this.activePeriod.from_date
            ).format("DD/MM/YYYY");
            this.activePeriod.to_date = moment(
              this.activePeriod.to_date
            ).format("DD/MM/YYYY");
          }
        })
        .catch((error) => {
          this.periodReport = null;
          this.activePeriod = null;
          this.loadingChart = false;
          this.notActivePeriod = true;
          if (error.response.data.error === "Active period not found") {
            this.$swal.fire({
              icon: "error",
              title: "Erro!",
              text: "Período ativo não encontrado.",
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Erro!",
              text: error.response.data.error,
            });
          }
        });
    },

    async notification(type, payload) {
      const textTutor =
        "Parece que algumas informações estão ausentes. Gostaria de solicitar o tutor a inclusão dos dados necessários?";
      const textTeacher =
        "Parece que algumas informações estão ausentes. Gostaria de solicitar aos professores a inclusão dos dados necessários?";

      this.$swal
        .fire({
          title: "Notificação",
          text: type === "period_tutor" ? textTutor : textTeacher,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Notificar",
          cancelButtonText: "Voltar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await httpRda
                .post(
                  `/bimontly-report/${this.studentId}/notifications`,
                  payload
                )
                .then(() => {
                  this.$swal.fire({
                    icon: "success",
                    title: "Notificação enviada!",
                    text: "Notificação enviada com sucesso.",
                  });
                });
            } catch (error) {
              this.$swal.fire({
                icon: "error",
                title: "Erro ao notificar!",
                text: error.response.data.error,
              });

              return error;
            }
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel notificar!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error;
        });
    },

    async notifyTutor() {
      await this.notification("period_tutor", {
        type: "period_tutor",
      });
    },

    async notifyTeacher() {
      await this.notification("period_teacher", {
        type: "period_teacher",
        subject_id: this.subject_id,
      });
    },

    async getSubjectList() {
      const response = await httpRda.get(
        `students/${this.studentId}/subjects-select?period_report=true`
      );
      this.subjectList = response.data.subjects;
      const cycleData = {
        cycle_name: response.data.conditionalPregression?.cycle_name,
        cycle_designation:
          response.data.conditionalPregression?.cycle_designation,
      };
      this.subjectPendencyList = (
        response.data.conditionalPregression?.subjects || []
      ).map(({ Subject }) => ({
        id: Subject.id,
        designation: Subject.designation,
        cycle_id: Subject.cycle_id,
        cycle_name: cycleData.cycle_name,
        cycle_designation: cycleData.cycle_designation,
      }));

      if (this.subjectList.length > 0) {
        this.selectSubject(this.subjectList[0].id);
      }
    },

    async selectSubject(subject_id) {
      this.loadingChart = true;
      this.subject_id = subject_id;
      const response = await httpRda.get(
        `/bimontly-report/${this.studentId}?subject_id=${subject_id}`
      );

      this.bimontlyReportData = response.data.results || [];
      this.chartData.labels = [];
      this.chartData.datasets[0].data = [];

      // Mapear os rótulos do eixo x
      this.chartData.labels = this.bimontlyReportData.map(
        (item) => item.to_date
      );

      // Mapear os dados incluindo col_number para as linhas verticais
      this.chartData.datasets[0].data = this.bimontlyReportData.map((item) => ({
        y: item.percentage ? Number(item.percentage).toFixed(0) : item.total,
        col_number: item.col_number,
        cycleId: this.cycle.id,
      }));
      await this.getTopicWithDescription(subject_id);
      await this.getTopicWithStatus(subject_id);

      this.loadingChart = false;
    },
    async getTopicWithDescription(subject_id) {
      const response = await httpRda.get(
        `/students/${this.studentId}/get_topics_with_description`,
        {
          params: {
            subject_id: subject_id,
            status: ["A", "AN", "EE"],
          },
        }
      );

      this.subjectTopics = response.data.topics.reduce((acc, item) => {
        let subjectTopicWithTitle = { ...item, title: "" };
        if (item.status === "A") {
          subjectTopicWithTitle.title = "Conteúdos aprendidos";
          acc.push(subjectTopicWithTitle);
        } else if (item.status === "AN") {
          subjectTopicWithTitle.title = "Conteúdos ainda não aprendidos";
          acc.push(subjectTopicWithTitle);
        } else if (item.status === "EE") {
          subjectTopicWithTitle.title = "Conteúdos em estudo";
          acc.push(subjectTopicWithTitle);
        }

        return acc;
      }, []);
    },

    async getTopicWithStatus(subject_id) {
      const response = await httpRda.get(
        `/students/${this.studentId}/get_topics_with_status`,
        {
          params: {
            subject_id: subject_id,
            status: ["A", "*"],
            count: true,
          },
        }
      );

      this.subjectWithStatus = response.data.topics.reduce((acc, item) => {
        if (item.status === "A" || item.status === "*") {
          acc.push(item);
        }

        return acc;
      }, []);
    },

    async getAllData() {
      await this.getStudent();
      await this.getYearAttendance();
      this.getPeriodReport();
      await this.getSubjectList();
    },
  },

  async created() {
    await this.getAllData();
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/variables.scss";

.center-icons {
  display: flex;
  justify-content: space-evenly;
}

.title {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .tags_count {
    background-color: #68c5b7;
    font-size: 18px;
    border-radius: 3px;
    color: #fff;
    margin-left: 10px;
    padding: 3px 10px;
    height: max-content;
  }
}

.list-top {
  margin-top: 30px;
  margin-bottom: 30px;
}

.list-teacher {
  background-color: $white;
  border: 1px solid $grey5;
  border-radius: 10px;
  margin-bottom: 15px;
  min-height: 80px;

  &:hover {
    border-color: transparent;
    background-image: linear-gradient($white, $white),
      radial-gradient(circle at top left, $orange, $purple);
    background-origin: border-box;
    background-clip: content-box, border-box;
  }

  p {
    margin: 0;
  }

  .disciplines {
    .name {
      display: inline-block;
      line-height: 22px;

      .comma {
        margin-right: 4px;
      }

      &:last-child {
        .comma {
          display: none;
        }
      }
    }
  }

  .cycles {
    display: flex;
    flex-wrap: wrap;

    .tags {
      background-color: $blue;
      border-radius: 5px;
      color: $white;
      font-weight: $bold;
      line-height: 28px;
      margin: 3px 12px 3px 0;
      max-width: 58px;
      padding: 0 3px;
      text-align: center;
      vertical-align: middle;
    }
  }
}

.outline {
  color: #fff !important;
  background: transparent;
  max-width: 220px !important;
  margin-right: 20px;

  &:hover {
    color: #68c5b7 !important;
  }
}

.col {
  display: flex;
  align-items: center;

  img {
    margin-right: 40px;
  }

  .content-meeting {
    display: flex;
    flex-direction: row;
    gap: 32px;
    width: 100%;

    h5 {
      font-size: 18px;
      white-space: nowrap;
      margin: 0;
    }

    .observacao-column {
      display: flex;
      flex-direction: column;
      align-self: center;
      justify-self: center;
      gap: 8px;

      p {
        margin: 0;
        font-size: 18px;
        line-break: normal;
        word-break: keep-all;
        overflow-wrap: break-word;
        hyphens: auto;
        text-align: justify;
      }
    }

    .column {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-between;
      gap: 4px;
      width: 100%;

      p {
        margin: 0;
        font-weight: 400;
        white-space: nowrap;
        font-size: 18px;
        white-space: normal;
        word-break: break-word;
      }

      &.two {
        min-width: 650px;
      }
    }

    .student-detail {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;

      @media (max-width: 1310px) {
        max-width: 300px;
      }

      p {
        font-size: 18px;
        white-space: nowrap;
        margin: 0;
      }
    }
  }
}

.profile-row {
  background: -webkit-linear-gradient(left, #36b67d, #6883c5);
  border-radius: 10px;
  color: $white;
  margin-top: 30px;
  padding: 28px 10px;
  position: relative;
  width: 100%;
  flex-wrap: nowrap;

  &:after {
    content: none;
    right: 0;
    pointer-events: none;
    position: absolute;
    top: -5px;
  }

  .col {
    display: flex;
    align-items: center;

    img {
      margin-right: 40px;
    }
  }
}

.attendance-advice {
  background-color: #ef6549;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  padding: 10px 10px;

  display: flex;
  align-self: center;
  justify-self: center !important;

  p {
    color: #fff;
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 1px;
  }
}

.outline {
  color: #68c5b7 !important;
  background: transparent;

  &:hover {
    color: #fff !important;
  }
}

.col-observacoes {
  border-radius: 10px;
  padding: 15px 20px 15px 20px;
  background-color: #fff;
}

.center-itens {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.flag-box {
  width: 24px;
  height: 24px;
  background-color: #36b67d;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.subtitle-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  padding: 0;
}

.flag-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  font-size: 16px;

  .subtitle {
    display: flex;
    flex-direction: row;
    gap: 12px;
  }
}

.status-content {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #68c5b7;
  widows: 48px;
  height: 28px;
  border-radius: 5px;
  max-width: 48px;
}

.register-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;

  .title-status-content {
    display: flex;
    flex-direction: column;
    font-size: 20px;
    gap: 8px;
    border-bottom: 1px solid #b3b3b3;
    width: 100%;

    h5 {
      white-space: nowrap;
    }
  }

  .title-format {
    padding-top: 56px;
    font-size: 20px;
    font-weight: 700;
    color: #666666;
  }

  .register-period {
    display: flex;
    width: 100%;
    gap: 24px;
    flex-direction: column;

    ul {
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 24px;
      max-width: 340px;
    }

    .register-item {
      align-self: flex-start;
      padding-right: 20px;
    }
  }

  .register-cycle {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .register-cycle-item {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 20px;
      width: 100%;

      & span:first-child {
        font-weight: 700;
      }
    }
  }
}

.chart-container {
  display: flex;
  flex-direction: column;

  h3 {
    font-weight: 700;
    padding-bottom: 16px;
    font-size: 20px;
    color: #666666;
  }

  .flag-percentage {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    width: 100%;
    color: #666666;

    &:last-child {
      margin-right: 50px;

      .flag-box:before {
        content: "";
        width: 1px;
      }
    }

    .flag-box:before {
      content: "";
      height: 342px;
      width: 5px;
      background-color: #b230665e;
      top: 32px;
      position: absolute;
    }
  }

  .flag-wrapper {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-bottom: 24px;
  }
}

.approved-btn {
  margin-left: 25px;
  color: #fff !important;
  background: transparent;
  max-width: 220px !important;
  margin-right: 20px;
}

.loading-spinner {
  span {
    color: #b23066;
  }

  display: flex;
  height: 100vh;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
}

.knowledge-menu {
  padding-left: 10px;

  .menu-sidebar-title {
    padding-bottom: 16px;
    font-weight: 600;
    font-size: 14px !important;
  }

  .side-item,
  .menu-sidebar-title {
    padding: 8px 12px !important;

    span {
      padding: 0px !important;
    }

    white-space: nowrap;
    font-size: 18px;

    &.active {
      &:after {
        content: "";
        background: $gradient1;
        border-radius: 10px;
        display: block;
        height: 24px;
        position: absolute;
        left: 0;
        bottom: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 4px;
      }

      &:before {
        all: unset !important;
      }

      background-color: transparent !important;
    }

    &:hover {
      background-color: transparent !important;

      &:after {
        content: "";
        border-radius: 10px;
        display: block;
        position: absolute;
        height: 24px;
        left: 0;
        bottom: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 4px;
        background-color: #b3b3b3 !important;
      }

      &:before {
        all: unset !important;
      }
    }
  }
}

.notify-button {
  background-color: transparent !important;
  text-decoration: underline;
  display: inline-block;
  color: #68c5b7;
  font-weight: 700;
  border: 0;
}

.font-bold {
  font-weight: 700 !important;
}
</style>
